import { EmailPreviewLayoutProps } from '../types';
import { EmailRecipient, FileDto } from 'nekst-api';

import DOMPurify from 'dompurify';
import React from 'react';

import styles from './EmailPreview.module.scss';
import { List, useShowContextRequired } from 'ui-builder';
import { FilePreview, RowRepeater } from 'features/nekst-widgets';
import { EmailPreviewResponse } from "../emailPreviewService";
import gmailIcon from './gmail.png';


function FilePreviewRow() {
  const showContext = useShowContextRequired<FileDto>();

  return (
    <FilePreview data={showContext.data!} small />
  )
}

function EmailProviderIcon(props: {
  preview: EmailPreviewResponse
}) {
  const provider = props.preview.sender.emailProvider;

  if (provider === 'gmail') {
    return (
      <img src={gmailIcon} alt="test" className={styles.icon} title="The email will be sent using Gmail connection" />
    );
  } else {
    return null;
  }
}

export default function EmailPreviewLayoutWeb(props: EmailPreviewLayoutProps) {
  const emailPreview = props.preview;

  const { recipients, cc, bcc } = props;
  return (
    <>
     <span>
        Email will be sent from
       {' '}
       {props.sendFromName}
       .
       {' '}
       (To change the sender, go back and update the task.)
        <br />
        <br />
        Please review the email message preview below before sending:
        <br />
        <br />
      </span>
      <div className={styles.emailPreview}>
        <div className={styles.from}>
          <b>{emailPreview.sender.name.fullName}</b>
          {' '}
          &lt;
          {emailPreview.sender.primaryEmail}
          &gt;
          <EmailProviderIcon preview={props.preview} />
        </div>
        <div className={styles.to}>
          To:
          {' '}
          {
            recipients.map(
              (item: EmailRecipient) => {
                return (
                  <span className={styles.recipient}>
                    <b>{item._profile!.name.fullName}</b>
                    {' '}
                    &lt;
                    {item._profile?.primaryEmail}
                    &gt;
                  </span>
                );
              },
            )
          }
        </div>
        {!!cc.length && (
          <div className={styles.cc}>
            Cc:
            {' '}
            {
              cc.map(
                (item: EmailRecipient) => {
                  return (
                    <span className={styles.recipient}>
                      <b>{item._profile!.name.fullName}</b>
                      {' '}
                      &lt;
                      {item._profile?.primaryEmail}
                      &gt;
                    </span>
                  );
                },
              )
            }
          </div>
        )}
        {!!bcc.length && (
          <div className={styles.bcc}>
            Bcc:
            {' '}
            {
              bcc.map(
                (item: EmailRecipient) => {
                  return (
                    <span className={styles.recipient}>
                      <b>{item._profile!.name.fullName}</b>
                      {' '}
                      &lt;
                      {item._profile?.primaryEmail}
                      &gt;
                    </span>
                  );
                },
              )
            }
          </div>
        )}
        <div className={styles.subject}>
          Subject:
          {' '}
          {props.preview.subject}
        </div>
        <div
          className={styles.body}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(emailPreview.preview) }}
        />
      </div>

      <List getDataFunc={async () => emailPreview.attachedFiles}>
        <RowRepeater>
          <FilePreviewRow />
        </RowRepeater>
      </List>
    </>

  );

}
